import {
  CardAction,
  CardState,
  SET_CARDS,
  SET_CARDS_LOADED,
  SET_CARD_FILTER,
  SET_SELECTED_CARD_ID,
  SET_SHOW_PAY_IN_MODAL,
  SET_TOTAL_CARDS,
} from '../types'

const initialState: CardState = {
  cards: [],
  totalCards: 0,
  isCardsLoaded: false,
  showPayInModal: false,
  cardFilter: {
    customerName: '',
    statuses: [],
    pageIndex: 1,
    pageSize: 15,
  },
}

export const cardReducer = (
  state = initialState,
  action: CardAction
): CardState => {
  switch (action.type) {
    case SET_CARDS:
      return {
        ...state,
        cards: action.payload,
      }
    case SET_SELECTED_CARD_ID:
      return {
        ...state,
        selectedCardId: action.payload,
      }
    case SET_TOTAL_CARDS:
      return {
        ...state,
        totalCards: action.payload,
      }
    case SET_CARDS_LOADED:
      return {
        ...state,
        isCardsLoaded: action.payload,
      }
    case SET_SHOW_PAY_IN_MODAL:
      return {
        ...state,
        showPayInModal: action.payload,
      }
    case SET_CARD_FILTER:
      return {
        ...state,
        cardFilter: action.payload,
      }
    default:
      return state
  }
}
